//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"ComponentsCreation",1,1],[0,"Csys",1,"CartesianCoordinateSystem",0],[0,"DisplayScaleFactor",1,0],[0,"FixedSizeDatum",1,1]],[[["info","xform_exists","xform_origin","xform_orientation","xform_scale"],"GetWaveLinkInformation",{},0,0]],[]];
SPLM.Features.DatumCsysBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DatumCsysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;